module.exports = __webpack_public_path__ + "static/media/Kevin.3e71b695.png";